import { wallFacadeFromJSON, WallFacadeRecord } from "common/records/WallFacade";
import { RootActions, RootState } from "common/reducers";
import { RECEIVE_WALL_FACADE } from "common/reducers/wallFacade.actions";
import { receive } from "common/reducers/Utils";
import { Map, Record } from "immutable";

export const WallFacadeStateRecord = Record({
  byId: Map<number, WallFacadeRecord>(),
  lastSavedById: Map<number, WallFacadeRecord>(),
  unsavedId: -1,
});

export const initialState = WallFacadeStateRecord();

export type WallFacadeState = typeof initialState;

export const reducer = (state: RootState, action: RootActions): RootState => {
  const model = "wallFacades";
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_WALL_FACADE:
      return receive(state, model, wallFacadeFromJSON(action.payload.wallFacade));

    default:
      return state;
  }
};
